import { compareStrWithKeyPath } from 'automation-ui-core/objectComparators';
export const PERSONALIZATION_PROPERTIES_BLOCKLIST = ['dealstage.probability'];
export const _filterBlockList = property => !(PERSONALIZATION_PROPERTIES_BLOCKLIST.includes(property.name) && property.hubspotDefined);
export const _filterHiddenProperty = ({
  hidden
}) => !hidden;
const _sorter = compareStrWithKeyPath(['label']);
export const getFormattedPersonalizationProperties = ({
  propertiesByGroup
}) => {
  const updateProperties = propertiesByGroup.map(propertyGroup => Object.assign({}, propertyGroup, {
    properties: propertyGroup.properties.filter(_filterBlockList).filter(_filterHiddenProperty).sort(_sorter)
  }));
  return updateProperties;
};